export const authConstant = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  SIGNUP_REQUEST: "SIGNUP_REQUEST",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_FAILURE: "SIGNUP_FAILURE",
  LOGOUT_REQUEST: "LOGOUT_REQUEST",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  LOGOUT_FAILURE: "LOGOUT_FAILURE",
  CODE_REQUEST: "CODE_REQUEST",
  CODE_SUCCESS: "CODE_SUCCESS",
  CODE_FAILURE: "CODE_FAILURE",
  VERIFY_REQUEST: "VERIFY_REQUEST",
  VERIFY_SUCCESS: "VERIFY_SUCCESS",
  VERIFY_FAILURE: "VERIFY_FAILURE",
  PICTURE_UPDATE_REQUEST: "PICTURE_REQUEST",
  PICTURE_UPDATE_SUCCESS: "PICTURE_SUCCESS",
  PICTURE_UPDATE_FAILURE: "PICTURE_FAILURE",
  NOTIFICATION_REQUEST: "NOTIFICATION_REQUEST",
  NOTIFICATION_SUCCESS: "NOTIFICATION_SUCCESS",
  NOTIFICATION_FAILURE: "NOTIFICATION_FAILURE",
  PROFILE_UPDATE_REQUEST: "PROFILE_UPDATE_REQUEST",
  PROFILE_UPDATE_SUCCESS: "PROFILE_UPDATE_SUCCESS",
  PROFILE_UPDATE_FAILURE: "PROFILE_UPDATE_FAILURE",
  PASS_RESET_EMAIL_REQUEST: "PASS_RESET_EMAIL_REQUEST",
  PASS_RESET_EMAIL_SUCCESS: "PASS_RESET_EMAIL_SUCCESS",
  PASS_RESET_EMAIL_FAILURE: "PASS_RESET_EMAIL_FAILURE",
  PASS_UPDATE_REQUEST: "PASS_UPDATE_REQUEST",
  PASS_UPDATE_SUCCESS: "PASS_UPDATE_SUCCESS",
  PASS_UPDATE_FAILURE: "PASS_UPDATE_FAILURE",
};
